import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `CheckboxWidget` is a simple widget to render a checkbox and an optional label.
 *
 * @param {function} toggleCallback - Callback function to be called when the checkbox is toggled.
 * It takes a boolean as parameter indicating if the checkbox is checked or unchecked.
 * @param {boolean} [checked] - Whether the checkbox should be checked or not.
 * @param {Renderer} [label] - Renderer labeling the checkbox.
 * @param {string} [dataTestName] - A string to find the checkbox within the test framework.
 * @param {string} [cssClass] - Optional additional css classes.
 */
export default class CheckboxWidget extends Widget {
	constructor({
		toggleCallback,
		checked = false,
		label = "",
		dataTestName = "",
		cssClass = "",
	}) {
		super(...arguments);

		this._toggleCallback = toggleCallback;
		this._checked = checked;
		this._label = label;
		this._dataTestName = dataTestName;
		this._cssClass = [cssClass, { "labeled-checkbox": this._label }];
	}

	renderContentOn(html) {
		html.span(
			{ klass: this._cssClass, "data-test": this._dataTestName },
			html.input(this._getOptions()),
			this._label,
		);
	}

	_getOptions() {
		const options = {
			type: "checkbox",
			click: this._onClick.bind(this),
		};
		if (this._checked) options.checked = true;

		return options;
	}

	_onClick() {
		const checkbox = this.asJQuery().find("input").get(0);
		this._toggleCallback(checkbox.checked);
	}
}
